export default {
  intranetOldHost: process.env.VUE_APP_INTRANET_OLD
}
